<script lang="ts">
  import type { RecommendationProduct, RecommendedProduct } from "../../../interfaces/RecommendationProduct"

  import ColorCircle from "../../Common/ColorCircle.svelte"
  import Circle from "../../Common/Circle.svelte"
  import Caption from "../../Common/Caption.svelte"
  
  export let product: RecommendedProduct

  const hideOptionTitles = false

  $: options = hideOptionTitles
    ? Object.values(product.options)
    : Object.entries(product.options).map(option => `${option[0]} ${option[1]}`)

  $: color = (product as RecommendationProduct).color
  $: subscription = (product as RecommendationProduct).subscription
</script>

<div class="product-options-container {color ? "has-color" : ""}">
  {#if color}
    <ColorCircle
      backgroundColor={color}
      size={10}
      class="product-option-color-circle"
    />
  {/if}
  {#each options as option, index}
    <Caption class="product-option">
      {option}
    </Caption>
    {#if index !== options.length -1 || subscription}
      <Circle
        backgroundColor="#DDDDDD"
        size={3}
        class="product-option-circle-separator"
      />
    {/if}
  {/each}
  {#if subscription}
    <Caption class="product-option">
      {subscription.name}
    </Caption>
  {/if}
</div>
